import {default as Obj} from "./abstract/Object";
import FilterItem from "./FilterItem";

export default class FilterGroup extends Obj {

  title;
  items;

  constructor(props) {
    super();

    this.initializeAttributes(props, {
      items: (value) => FilterItem.list(value)
    });
  }
}